/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MedicationScheduleDetails from './medication-schedule-details';
import MedicationScheduleDetailsDetail from './medication-schedule-details-detail';
import MedicationScheduleDetailsUpdate from './medication-schedule-details-update';
import MedicationScheduleDetailsDeleteDialog from './medication-schedule-details-delete-dialog';

const MedicationScheduleDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MedicationScheduleDetails />} />
    <Route path="new" element={<MedicationScheduleDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<MedicationScheduleDetailsDetail />} />
      <Route path="edit" element={<MedicationScheduleDetailsUpdate />} />
      <Route path="delete" element={<MedicationScheduleDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicationScheduleDetailsRoutes;
